export default {
  sync: 'SYNC',
  upload_labels: 'LABELS',
  upload_models: 'MODELS',
  sync_videos: 'SYNC VIDEOS',
};
